// Generated from SVG to Code Figma Plugin

export const Getfeatured = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 82 82" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect
      height="31.6145"
      width="31.6145"
      rx="15.8072"
      stroke="currentColor"
      strokeWidth="5.5"
      x="25.1929"
      y="25.1927"
    />
    <path d="M41 7.40967V16.3012" stroke="currentColor" strokeLinecap="round" strokeWidth="5.5" />
    <path d="M41 65.6988V74.5904" stroke="currentColor" strokeLinecap="round" strokeWidth="5.5" />
    <path d="M65.6987 41H74.5903" stroke="currentColor" strokeLinecap="round" strokeWidth="5.5" />
    <path d="M7.40967 41H16.3012" stroke="currentColor" strokeLinecap="round" strokeWidth="5.5" />
    <path d="M65.0706 17.2892L58.7833 23.5765" stroke="currentColor" strokeLinecap="round" strokeWidth="5.5" />
    <path d="M16.3013 17.2892L22.5886 23.5765" stroke="currentColor" strokeLinecap="round" strokeWidth="5.5" />
    <path d="M65.0706 64.7108L58.7833 58.4235" stroke="currentColor" strokeLinecap="round" strokeWidth="5.5" />
    <path d="M17.2891 64.7108L23.5763 58.4235" stroke="currentColor" strokeLinecap="round" strokeWidth="5.5" />
  </svg>
);
